import React from "react";
import { useSelector } from "react-redux";
import { removeCurrencySign, formatCurrency } from "../../../Constants/utils";
import { getAvgSaleValue } from "../../../Redux/features/Dashboard/Charts/avgSaleValueChartSlice";
import { CommonChart } from "./CommonChart";

export const AvgSaleValueChart = ({
  merchantId,
  activeType,
  presentDate,
  avgSaleValueChartInView,
  avgSaleValueChartRef,
  selectedOutletIds = [],
}) => {
  const avgSaleValueChart = useSelector((state) => state.avgSaleValueChart);
  const chartKey = "avgSaleValueChart";

  return (
    <>
      <CommonChart
        componentRef={avgSaleValueChartRef}
        activeType={activeType}
        formatFunction={removeCurrencySign}
        presentDate={presentDate}
        sliceCallback={getAvgSaleValue}
        yAxisText={"Metric (e.g., revenue in $)"}
        reduxState={avgSaleValueChart}
        reduxStateKey={"avgSaleValueData"}
        reduxStateTotalKey={"totalAvgSaleValue"}
        valueKey={"total_revenue"}
        chartKey={chartKey}
        merchantId={merchantId}
        chartInView={avgSaleValueChartInView}
        title={"Average Order Value"}
        totalValueFunction={formatCurrency}
        selectedOutletIds={selectedOutletIds}
      />
    </>
  );
};
